import SfcUtil from "@/lib/sfc-util.js"

export default {
	setIp({ commit }, req) {
		let ip = ""
		try {
			ip = req.headers['x-forwarded-for'].split(',')[0] || req.connection.remoteAddress
		} catch (e) {
			ip = ""
		}
		commit('updateCurrentIp', ip)
	},

	async getTaxJson({ commit, state }) {
		if (!state.taxInfo) {
			const taxDataUrl = `${state.config.taxDataJsonUrl}`
			const taxResponse = await this.app.$httpService.get(taxDataUrl, {})
			commit('updateTaxInfo', taxResponse)
		}
		return state.taxInfo
	},
	async getGeneralDataJson({ commit, state }) {
		if (!state.generalData) {
			const response = await this.app.$httpService.get(`${state.config.s3ResourceHost}/data/general_data.json`)
			commit('updateGeneralData', response.tax_filing_statuses)
		}
		return state.generalData
	},

	async getStateFromIp({ commit, state }) {
		const query = `
				query{
					state_from_ip(ip_address: "${state.ip}"){
						id
						name
						slug
						sfc_id
					}
				}
			`
		if (!state.stateFromIp) {
			const response = await this.app.$httpService.graphql(query)
			commit('updateStateFromIp', response.data.state_from_ip)
		}

		return state.stateFromIp
	},

	async buildIntroContent({ commit }, params){

		const query =
			`
				query{
					no_graphql_cache
					intro_to_529_content(slug: "${params.slug}", category: "intro-to-529s"){
						title
						content
						shares
						url
						date
						canonical_url
						facebook_image_url
						meta_description
						meta_title
						meta_keywords
						slug
						hero_image_url
						popular_articles{
							title
							slug
							thumbnail_url
							url
						}
						table_of_contents{
							title
							url
							slug
						}
					}
				}
			`

		let content

		const response = await this.app.$httpService.graphql(query)

		content = response.data.intro_to_529_content

		content.sideBySideTocContent = content.content.split("<div class='side-by-side-content'></div>")[0]
		content.notSideBySideTocContent = content.content.split("<div class='side-by-side-content'></div>")[1]
		content.pagination = [{
			page: 1,
			url: "#"
		}, {
			page: 2,
			url: "#"
		}, {
			page: 3,
			url: "#"
		}]
		content.table_of_contents.map((currentPage, index) => {
			let nextPage;
			nextPage = index + 1;

			if (content.title == content.table_of_contents[index].title && nextPage <= content.table_of_contents.length) {
				content.nextPageUrl = content.table_of_contents[nextPage].url;
				content.nextPageTitle = content.table_of_contents[nextPage].title;
			}

			if (content.title == content.table_of_contents[index].title && index != 0) {
				content.prevPageUrl = content.table_of_contents[index - 1].url;
				content.prevPageTitle = content.table_of_contents[index - 1].title;
			}

			if (content.title == content.table_of_contents[index].title && index == 0) {
				content.pagination = [{
						page: 1,
						url: ""
					},
					{
						page: 2,
						url: content.table_of_contents[1].url
					},
					{
						page: 3,
						url: content.table_of_contents[2].url
					}
				];
			}

			if (content.title == content.table_of_contents[index].title && nextPage <= content.table_of_contents.length && index != 0 && index < content.table_of_contents.length - 3) {
				content.pagination = [{
						page: index + 1,
						url: content.table_of_contents[index].url
					},
					{
						page: index + 2,
						url: content.table_of_contents[index + 1].url
					},
					{
						page: index + 3,
						url: content.table_of_contents[index + 2].url
					}
				];
			}

			if (content.title == content.table_of_contents[index].title && index != 0 && index >= content.table_of_contents.length - 3) {
				if (index + 1 == content.table_of_contents.length - 2) {
					content.pagination[0]['page'] = index + 1;
					content.pagination[0]['url'] = content.table_of_contents[index].url
				} else {
					if (index == content.table_of_contents.length - 2) {
						content.pagination[0]['page'] = index;
						content.pagination[0]['url'] = content.table_of_contents[index - 1].url
					} else {
						content.pagination[0]['page'] = index - 1;
						content.pagination[0]['url'] = content.table_of_contents[index - 2].url
					}
				}
				if (index + 2 == content.table_of_contents.length - 1) {
					content.pagination[1]['page'] = index + 2;
					content.pagination[1]['url'] = content.table_of_contents[index + 1].url
				} else {
					if (index == content.table_of_contents.length - 2) {
						content.pagination[1]['page'] = index + 1
						content.pagination[1]['url'] = content.table_of_contents[index].url
					} else {
						content.pagination[1]['page'] = index
						content.pagination[1]['url'] = content.table_of_contents[index - 1].url
					}
				}
				if (index + 3 == content.table_of_contents.length) {
					content.pagination[2]['page'] = index + 3
					content.pagination[2]['url'] = content.table_of_contents[index + 2].url
				} else {
					if (index == content.table_of_contents.length - 2) {
						content.pagination[2]['page'] = index + 2
						content.pagination[2]['url'] = content.table_of_contents[content.table_of_contents.length - 1].url
					} else {
						content.pagination[2]['page'] = index + 1
					}
				}
			}
		})

		let linkRegex = /<a\s+(.*?)>/gm
		content.content = content.content.replace(linkRegex, "<a $1 target='_blank'>")

		return content
	},

	async buildArticleContent({ commit }, params){
		const query = `
			query{
				no_graphql_cache
				page_id(id:"article")
				article(slug: "${params.slug}"){
					id
					template_id
					title
					slug
					canonical_url
					meta_title
					meta_description
					meta_keywords
					facebook_image_url
					shares
					published_at
					updated_at
					locked
					thumbnail_image_url
					table_of_contents
					url
					is_visible_for_professional
					is_professional
					related_pages{
						id
						title
						slug
						thumbnail_image_url
						url
						published_at
						meta_description
					}
					author{
						id
						name
						thumbnail_url
						image_url
						short_bio
						bio
						position
						type{
							id
							name
						}
						visible
						slug
						has_author_footer_information
					}
					tags{
						id,
						name
					}
					categories{
						id,
						name
					}
					section_contents{
						name
						value
						type
					}
					template{
						id
						name
					}
				}
			}
		`

		const response = await this.app.$httpService.graphql(query)
		let article = response.data.article


		const contents = SfcUtil.convertContentToObject(article.section_contents)
		article.content = contents.content
		article.hero_image_url = contents.hero_image_url
		article.snippet = contents.snippet

		let linkRegex = /<a\s+(.*?)>/gm
		let emptyParagraphRegex = /<p><br><\/p>/gm
		article.content = article.content.replace(emptyParagraphRegex, " ")
		article.content = article.content.replace(linkRegex, "<a $1 target='_blank'>")

		return article
	},

	async trackLogin({ commit }, params){
		if (!params || typeof params !== 'object' || !params.email) {
      console.error('Invalid params object or email is missing');
      return
    }
		const query = `
			mutation{
				track_college_savings_user_login(email: "${params["email"]}"){
					id
				}
			}
		`
		this.app.$httpService.graphql(query);
	},
}
